exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* .hrVertical{\r\n    border-right: 0.05rem solid;\r\n    height: 3.5rem;\r\n    display: block;\r\n} */\r\n\r\n\r\n.hrVertical {\r\n    border-right: 0.1rem solid !important;\r\n    /* height: 3.5rem !important; */\r\n    display: inline-block !important;\r\n    -webkit-transition: auto !important;\r\n    transition: auto !important;\r\n}\r\n\r\n\r\n.ddl-site\r\n{\r\n    width: 300px;\r\n    min-width: 300px;\r\n}\r\n\r\n\r\n.details-link\r\n{\r\n    cursor: pointer;\r\n    padding-top: 1px!important;\r\n    padding-bottom: 1px!important;\r\n    color: white!important;\r\n}\r\n\r\n\r\n::ng-deep .ui-dropdown-item-empty, .ui-dropdown-label-empty\r\n{\r\n    text-indent: initial;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/trip-cycles-2/trip-cycles-2.component.css
// module id = ../../../../../src/app/trip-cycles-2/trip-cycles-2.component.css
// module chunks = main